<provider-navbar></provider-navbar>
<main role="main">
  <router-outlet></router-outlet>
</main>
<portals-shared-styles></portals-shared-styles>
